import {
  callApiTaoVanBanDi,
  callApiLayDanhSachVanBanDi,
  callApiLayMultiDanhSachVanBanDi,
  callApiUploadFiles,
  callApiLaySoLuongVanBanDi,
  callXemChiTietVanBanDi,
  callApiSuaVanBanDi,
  callApiTrinhKy,
  callApiXoaVanBanDi,
  callApiXinYKien,
  callApiLayDanhSachVanBanDenCuaVanBanDi,
  callApiMultiVanBanDen,
  callApiChoYKien,
  callApiKySoFile,
  callApiDuyetVB,
  callApiCapSo,
  callApiTraSo,
  callApiNhanSo,
  callApiHuyDuyet,
  callApiHuyTrinhKy,
  callApiLayDanhSachNguoiDuocTraLai,
  callApiTraLai,
  callApiGetListXinSo,
  callApiBanHanh,
  callApiSaoChep,
  callApiBanHanhBoSung,
  callApiTrinhKyTiepTheo,
  callApiThuHoiDaBanHanh,
  callApiLayDonViDaBanHanh,
  callApiPhanXuLy,
  callApiThuHoiSo,
  callApiLayLSCapNhat,
  callApiLayLSTraLai,
  callApiLayLSThuHoi,
  callApiLayLSHuyDuyet,
  callApiLayLuongXuLy,
  callApiLayLichSuKyDuyet,
  callGetDonViNgangCap,
  callApiLayNguoiXuLyTiepTheo,
  callApiLayLuongKyDuyet,
  callApiExportVB,
  callApiDoiSo,
  callApiLayLSTheoDoiVB,
  callApiGetDonViDaBanHanh,
  callApiGanDonViVaoFile,
  callApiGetSoDiLonNhat,
  callApiXoaYKien,
  callApiSuaYKien,
  callApiUpdateYKien,
  callApiSuaXinYKienVanBanDi,
  callApiLayLuongXuLyToken,
  callApiFileDinhKem,
  callApiXemKyDienTu,
  callApiCheckSoDi,
  callApiGetFileNhieuVanBan,
  callApiCheckTrungSoDi,
  callApiGoiSoBiGiu,
  callThongTinChungVanBanDi,
  callThongTinGuiVanBan,
  callThongTinYKien,
  callGuiLaiFileDonVi,
  callApiGetDonViCanBo,
  callApiDanhDauVanBanKhongBanHanhLai,
  callApiLayLichSuLienThong,
  callApiSuaVanBanDiBanHanh,
  callApiDeleteFileVanBanDi,
  callApiBanHanhVanBanError,
  callApiBanHanhTruc,
  callApiSinhSoNoiBo,
  callApiChuyenVung,
  callApiGetDanhSachVanThuLanhDaoXinSoBo,
} from "@/api/van-ban-di";
import { closeIfNotFound } from "@/constants/vanBanDi";
import Vue from "vue";
import {
  callApiLaySoLuongVanBanDiDashboard,
  callApiThemDonViNgoaiHeThong,
  callApiUpdateFileVanBanDi
} from "../../../api/van-ban-di";

const taoVanBanDi = async (context, payload) => {
  const response = await callApiTaoVanBanDi(payload.data);
  if (response && response.data.IsSuccess) {
    laySoLuongVanBanDi(context);
    payload.onSuccess && payload.onSuccess(response.data.Data);
    if(payload.data.isCapSoVanBanGiay !== true ) {
      Vue.toasted.global.showSuccessMessage({
        message: "Thêm mới văn bản trình thành công",
      });
    }
  } else {
    payload.fail && payload.fail();
    Vue.toasted.global.showErrorMessage({
      message: response.data.Messages[0],
    });
  }
};

const taoVBDiTrinhKy = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiTaoVanBanDi(payload)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const suaVanBanDi = async (context, payload) => {
  const response = await callApiSuaVanBanDi(payload.data);
  if (response && response.data.IsSuccess) {
    payload.onSuccess && payload.onSuccess(response.data.Data);
  } else {
    payload.onFail && payload.onFail(response.data.Data);
    Vue.toasted.clear();
    Vue.toasted.global.showErrorMessage({
      message: response.data.Messages[0],
    });
    if (response.data.StatusCode === 404) {
      payload.onFail && payload.onFail(response.data.Data);
    }
  }
};
const suaVanBanDiBanHanh = async (context, payload) => {
  const response = await callApiSuaVanBanDiBanHanh(payload.data);
  if (response && response.data.IsSuccess) {
    payload.onSuccess && payload.onSuccess(response.data.Data);
  } else {
    payload.onFail && payload.onFail(response.data.Data);
    Vue.toasted.clear();
    Vue.toasted.global.showErrorMessage({
      message: response.data.Messages[0],
    });
    if (response.data.StatusCode === 404) {
      payload.onFail && payload.onFail(response.data.Data);
    }
  }
};

const layDanhSachVanBanDi = (context, payload) => {
  context.commit("SET_DANH_SACH_VAN_BAN_DI", {});
  return new Promise((resolve, reject) => {
    callApiLayDanhSachVanBanDi(payload)
      .then((response) => {
        if (response && response.data.IsSuccess) {
          context.commit("SET_DANH_SACH_VAN_BAN_DI", response.data.Data);
        } else {
          Vue.toasted.global.showErrorMessage({
            message: response.data.Messages[0],
          });
        }
        resolve(response);
      })
      .catch((error) => {
        context.commit("SET_DANH_SACH_VAN_BAN_DI", {});
        reject(error);
      });
  });
};

const layDanhSachVanBanDiTraCuu = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiLayDanhSachVanBanDi(payload)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const updateFileVanBanDi = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiUpdateFileVanBanDi(payload)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const deleteFileVanBanDi = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiDeleteFileVanBanDi(payload)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const layMultiDanhSachVanBanDi = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiLayMultiDanhSachVanBanDi(payload)
      .then((response) => {
        if (response) {
          context.commit("SET_DANH_SACH_MULTI_VAN_BAN_DI", response.data.Data);
        }
        resolve(response);
      })
      .catch((error) => {
        context.commit("SET_DANH_SACH_MULTI_VAN_BAN_DI", {});
        reject(error);
      });
  });
};

const uploadFiles = async (context, payload) => {
  try {
    const response = await callApiUploadFiles(payload.data);
    if (response && response.data.IsSuccess) {
      payload.onSuccess && payload.onSuccess(response.data.Data);
    }
  } catch (error) {
    console.log(error);
  }
};

const getSoDiLonNhat = async (context, payload) => {
  try {
    const response = await callApiGetSoDiLonNhat(payload.data);
    if (response && response.data.IsSuccess) {
      payload.onSuccess && payload.onSuccess(response.data.Data);
    }
  } catch (error) {
    console.log(error);
  }
};

const getFileNhieuVanBan = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiGetFileNhieuVanBan(payload)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
  });
};

const capSo = async (context, payload) => {
  try {
    return  await callApiCapSo(payload)
  } catch (error) {
    console.log(error);
  }
};

const traSo = async (context, payload) => {
  try {
    const response = await callApiTraSo(payload.data);
    if (response && response.data.IsSuccess) {
      payload.onSuccess && payload.onSuccess(response.data.Data);
    } else {
      Vue.toasted.global.showErrorMessage({
        message: response.data.Messages[0],
      });
    }
  } catch (error) {
    console.log(error);
  }
};
const nhanSo = async (context, payload) => {
  try {
    const response = await callApiNhanSo(payload.data);
    if (response && response.data.IsSuccess) {
      payload.onSuccess && payload.onSuccess(response.data.Data);
      Vue.toasted.global.showSuccessMessage({
        message: "Giữ số thành công",
      });
    } else {
      Vue.toasted.global.showErrorMessage({
        message: response.data.Messages[0],
      });
    }
  } catch (error) {
    console.log(error);
  }
};

const ganDonViVaoFile = async (context, payload) => {
  try {
    const response = await callApiGanDonViVaoFile(payload.data);
    if (response && response.data.IsSuccess) {
      payload.onSuccess && payload.onSuccess(response.data.Data);
      Vue.toasted.global.showSuccessMessage({
        message: "Cập nhật đơn vị thành công",
      });
    } else {
      Vue.toasted.global.showErrorMessage({
        message: response.data.Messages[0],
      });
    }
  } catch (error) {
    console.log(error);
  }
};

const saoChep = async (context, payload) => {
  try {
    const response = await callApiSaoChep(payload.data);
    if (response && response.data.IsSuccess) {
      payload.onSuccess && payload.onSuccess(response.data.Data);
      Vue.toasted.global.showSuccessMessage({
        message: "Sao chép thành công",
      });
    } else {
      Vue.toasted.global.showErrorMessage({
        message: response.data.Messages[0],
      });
    }
  } catch (error) {
    console.log(error);
  }
};

const trinhKyTiepTheo = async (context, payload) => {
  try {
    const response = await callApiTrinhKyTiepTheo(payload.data);
    if (response && response.data.IsSuccess) {
      payload.onSuccess && payload.onSuccess(response.data.Data);
      Vue.toasted.global.showSuccessMessage({
        message: "Trình ký tiếp theo thành công",
      });
    } else {
      Vue.toasted.global.showErrorMessage({
        message: response.data.Messages[0],
      });
    }
  } catch (error) {
    console.log(error);
  }
};

const thuHoiSo = async (context, payload) => {
  try {
    const response = await callApiThuHoiSo(payload.data);
    if (response && response.data.IsSuccess) {
      payload.onSuccess && payload.onSuccess(response.data.Data);
      Vue.toasted.global.showSuccessMessage({
        message: "Thu hồi số đã xin thành công",
      });
    } else {
      Vue.toasted.global.showErrorMessage({
        message: response.data.Messages[0],
      });
    }
  } catch (error) {
    console.log(error);
  }
};

const layLichSuKyDuyet = async (context, payload) => {
  try {
    const response = await callApiLayLichSuKyDuyet(payload);
    if (response && response.data.IsSuccess) {
      context.commit("SET_LICH_SU_KY_DUYET", response.data.Data);
    } else {
      Vue.toasted.global.showErrorMessage({
        message: response.data.Messages[0],
      });
    }
  } catch (error) {
    console.log(error);
  }
};

const lichSuTheoDoiLienThong = async (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiLayLichSuLienThong(payload)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
  });
};
const layLichSuTheoDoiVB = async (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiLayLSTheoDoiVB(payload)
        .then((response) => {
          resolve(response);
          context.commit("SET_LICH_SU_THEO_DOI_VB", response.data.Data);
        })
        .catch((error) => {
          reject(error);
          Vue.toasted.global.showErrorMessage({
            message: response.data.Messages[0],
          });
        });
  });
};

const xemChiTiet = async (context, payload) => {
  try {
    const response = await callXemChiTietVanBanDi(payload);
    if (response && response.data.IsSuccess) {
      context.commit("SET_CHI_TIET_VAN_BAN_DI", response.data.Data);
    } else {
      Vue.toasted.global.showErrorMessage({
        message: response.data.Messages[0],
      });
      closeIfNotFound(response.data.Messages[0], payload.vm);
    }
  } catch (error) {
    console.log(error);
  }
};

const layThongTinChung = async (context, payload) => {
  return new Promise((resolve, reject) => {
    callThongTinChungVanBanDi(payload)
        .then((response) => {
          if (context.state.danhSachVanBanDi.PageData) {
            const result = context.state.danhSachVanBanDi.PageData.map(item => {
              if (item.Id === payload) {
                return {
                  ...item,
                  DaXem: true
                }
              }
              return item
            })
            context.commit("SET_DANH_SACH_VAN_BAN_DI", {
              ...context.state.danhSachVanBanDi,
              PageData: result
            })
          }

          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
  });
};

const guiLaiFileDonVi = async (context, payload) => {
  return new Promise((resolve, reject) => {
    callGuiLaiFileDonVi(payload)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
  });
};

const layThongTinGuiVanBan = async (context, payload) => {
  return new Promise((resolve, reject) => {
    callThongTinGuiVanBan(payload)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
  });
};

const chuyenVung = async (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiChuyenVung(payload)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
  });
};

const layThongTinYKien = async (context, payload) => {
  return new Promise((resolve, reject) => {
    callThongTinYKien(payload)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
  });
};

const DownloadFile = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiFileDinhKem(payload)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const GetMultiVanBanDen = async (context, payload) => {
  try {
    const response = await callApiMultiVanBanDen(payload);
    if (response && response.data.IsSuccess) {
      context.commit("SET_MULTI_VAN_BAN_DEN", response.data.Data);
    } else {
      Vue.toasted.global.showErrorMessage({
        message: response.data.Messages[0],
      });
    }
  } catch (error) {
    console.log(error);
  }
};

const getDanhSachVanBanDenCuaVanBanDi = async (context, payload) => {
  try {
    const response = await callApiLayDanhSachVanBanDenCuaVanBanDi(payload);
    if (response && response.data.IsSuccess) {
      context.commit("SET_VAN_BAN_DEN_VAN_BAN_DI", response.data.Data);
    } else {
      Vue.toasted.global.showErrorMessage({
        message: response.data.Messages[0],
      });
    }
  } catch (error) {
    console.log(error);
  }
};

const GetListXinSo = async (context, payload) => {
  try {
    const response = await callApiGetListXinSo(payload);
    if (response && response.data.IsSuccess) {
      context.commit("SET_LIST_XIN_SO", response.data.Data);
    } else {
      Vue.toasted.global.showErrorMessage({
        message: response.data.Messages[0],
      });
    }
  } catch (error) {
    console.log(error);
  }
};

const xoaYKien = async (context, payload) => {
  try {
    const response = await callApiXoaYKien(payload.data);
    if (response && response.data.IsSuccess) {
      payload.onSuccess && payload.onSuccess();
      Vue.toasted.global.showSuccessMessage({
        message: "Xóa ý kiến thành công",
      });
    } else {
      payload.onFailed && payload.onFailed();
      Vue.toasted.global.showErrorMessage({
        message: response.data.Messages[0],
      });
    }
  } catch (error) {
    console.log(error);
  }
};

const laySoLuongVanBanDi = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiLaySoLuongVanBanDi(payload)
      .then((response) => {
        if (response) {
          context.commit("SET_SO_LUONG_VAN_BAN_DI", response.data.Data);
        }
        resolve(response);
      })
      .catch((error) => {
        context.commit("SET_SO_LUONG_VAN_BAN_DI", []);
        reject(error);
      });
  });
};

const laySoLuongVanBanDiDashboard = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiLaySoLuongVanBanDiDashboard(payload)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const trinhKy = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiTrinhKy(payload)
      .then((response) => {
        resolve(response);
        laySoLuongVanBanDi(context);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const xoaVanBan = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiXoaVanBanDi(payload)
      .then((response) => {
        resolve(response);
        laySoLuongVanBanDi(context);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const xinYKien = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiXinYKien(payload)
      .then((response) => {
        resolve(response);
        laySoLuongVanBanDi(context);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const choYKien = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiChoYKien(payload)
      .then((response) => {
        resolve(response);
        laySoLuongVanBanDi(context);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const suaYKien = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiSuaYKien(payload)
      .then((response) => {
        resolve(response);
        laySoLuongVanBanDi(context);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const updateYKien = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiUpdateYKien(payload)
      .then((response) => {
        resolve(response);
        laySoLuongVanBanDi(context);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const suaXinYKienVanBanDi = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiSuaXinYKienVanBanDi(payload)
      .then((response) => {
        resolve(response);
        laySoLuongVanBanDi(context);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const kySoFile = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiKySoFile(payload)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const duyetVB = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiDuyetVB(payload)
      .then((response) => {
        resolve(response);
        laySoLuongVanBanDi(context);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const huyDuyetVB = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiHuyDuyet(payload)
      .then((response) => {
        resolve(response);
        laySoLuongVanBanDi(context);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const huyTrinhKy = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiHuyTrinhKy(payload)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const traLaiVB = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiTraLai(payload)
      .then((response) => {
        resolve(response);
        laySoLuongVanBanDi(context);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const thuHoiDaBanHanh = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiThuHoiDaBanHanh(payload)
      .then((response) => {
        resolve(response);
        laySoLuongVanBanDi(context);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const layDonViDaBanHanh = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiLayDonViDaBanHanh(payload)
      .then((response) => {
        if (response) {
          context.commit("SET_DON_VI_DA_BAN_HANH", response.data.Data);
        }
        resolve(response);
      })
      .catch((error) => {
        context.commit("SET_DON_VI_DA_BAN_HANH", {});
        reject(error);
      });
  });
};

const layDanhSachNguoiDuocTraLai = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiLayDanhSachNguoiDuocTraLai(payload)
      .then((response) => {
        if (response) {
          context.commit(
            "SET_DANH_SACH_NGUOI_DUOC_TRA_LAI",
            response.data.Data
          );
        }
        resolve(response);
      })
      .catch((error) => {
        context.commit("SET_DANH_SACH_NGUOI_DUOC_TRA_LAI", {});
        reject(error);
      });
  });
};

const banHanhVB = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiBanHanh(payload)
      .then((response) => {
        resolve(response);
        laySoLuongVanBanDi(context);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const banHanhVBLenTruc = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiBanHanhTruc(payload)
      .then((response) => {
        resolve(response);
        laySoLuongVanBanDi(context);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const banHanhVBError = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiBanHanhVanBanError(payload)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const danhDauVBKhongBanHanhLai = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiDanhDauVanBanKhongBanHanhLai(payload)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const banHanhBoSung = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiBanHanhBoSung(payload)
      .then((response) => {
        resolve(response);
        laySoLuongVanBanDi(context);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const phanXuLy = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiPhanXuLy(payload)
      .then((response) => {
        resolve(response);
        laySoLuongVanBanDi(context);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const layLSCapNhat = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiLayLSCapNhat(payload)
      .then((response) => {
        if (response) {
          context.commit("SET_LS_CAP_NHAT", response.data.Data);
        }
        resolve(response);
      })
      .catch((error) => {
        context.commit("SET_LS_CAP_NHAT", []);
        reject(error);
      });
  });
};

const layLSTraLai = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiLayLSTraLai(payload)
      .then((response) => {
        if (response) {
          context.commit("SET_LS_TRA_LAI", response.data.Data);
        }
        resolve(response);
      })
      .catch((error) => {
        context.commit("SET_LS_TRA_LAI", []);
        reject(error);
      });
  });
};

const layLSThuHoi = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiLayLSThuHoi(payload)
      .then((response) => {
        if (response) {
          context.commit("SET_LS_THU_HOI", response.data.Data);
        }
        resolve(response);
      })
      .catch((error) => {
        context.commit("SET_LS_THU_HOI", []);
        reject(error);
      });
  });
};

const layLSHuyDuyet = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiLayLSHuyDuyet(payload)
      .then((response) => {
        if (response) {
          context.commit("SET_LS_HUY_DUYET", response.data.Data);
        }
        resolve(response);
      })
      .catch((error) => {
        context.commit("SET_LS_HUY_DUYET", []);
        reject(error);
      });
  });
};

const setLuongXuLy = (context, response) => {
  if (response) {
    context.commit("SET_LUONG_XU_LY", response.data.Data);
  }
};

const layLuongXuLy = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiLayLuongXuLy(payload)
      .then((response) => {
        if (response.data.IsSuccess) {
          setLuongXuLy(context, response);
        } else {
          Vue.toasted.clear();
          Vue.toasted.global.showErrorMessage({
            message: response.data.Messages[0] || "Thao tác thất bại!",
          });
        }
        resolve(response);
      })
      .catch((error) => {
        context.commit("SET_LUONG_XU_LY", []);
        reject(error);
      });
  });
};

const layLuongXuLyToken = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiLayLuongXuLyToken(payload)
      .then((response) => {
        setLuongXuLy(context, response);
        resolve(response);
      })
      .catch((error) => {
        context.commit("SET_LUONG_XU_LY", []);
        reject(error);
      });
  });
};

const layDonViNgangCap = (context, payload) => {
  return new Promise((resolve, reject) => {
    callGetDonViNgangCap(payload)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const layNguoiXuLyTiepTheo = (context, id) => {
  return new Promise((resolve, reject) => {
    callApiLayNguoiXuLyTiepTheo(id)
      .then((response) => {
        if (response.data.IsSuccess) {
          context.commit("SET_NGUOI_XU_LY_TIEP_THEO", response.data.Data);
        } else {
          context.commit("SET_NGUOI_XU_LY_TIEP_THEO", []);
          Vue.toasted.clear();
          Vue.toasted.global.showErrorMessage({
            message: response.data.Messages[0] || "Thao tác thất bại!",
          });
        }
        resolve(response);
      })
      .catch((error) => {
        context.commit("SET_NGUOI_XU_LY_TIEP_THEO", []);
        Vue.toasted.clear();
        Vue.toasted.global.showErrorMessage({
          message: error.response.data.Messages[0] || "Thao tác thất bại!",
        });
        reject(error);
      });
  });
};

const layLuongKyDuyet = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiLayLuongKyDuyet(payload)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const exportVB = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiExportVB(payload)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const doiSoVB = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiDoiSo(payload)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const getDonViDaBanHanh = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiGetDonViDaBanHanh(payload)
      .then((response) => {
        if (response) {
          context.commit("SET_DV_DA_BAN_HANH", response.data.Data);
        }
        resolve(response);
      })
      .catch((error) => {
        context.commit("SET_DV_DA_BAN_HANH", []);
        reject(error);
      });
  });
};

const xemKyDienTu = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiXemKyDienTu(payload)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};
const checkSoDi = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiCheckSoDi(payload.data)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const checkTrungSoDi = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiCheckTrungSoDi(payload)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};



const checkSoBiGiu = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiGoiSoBiGiu(payload)
      .then((response) => {
        if (response) {
          context.commit("SET_DS_SO_BI_GIU", response.data.Data);
        }
        resolve(response);
      })
      .catch((error) => {
        context.commit("SET_DS_SO_BI_GIU", []);
        reject(error);
      });
  });
};

const getSinhSoNoiBo = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiSinhSoNoiBo(payload)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const themDonViNgoaiHeThong = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiThemDonViNgoaiHeThong(payload.data)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const getDonViCanBo = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiGetDonViCanBo(payload)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
  });
};

const getDanhSachVanThuLanhDaoXinSoBo = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiGetDanhSachVanThuLanhDaoXinSoBo(payload)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
  });
};

export default {
  getDonViCanBo,
  checkSoBiGiu,
  checkTrungSoDi,
  themDonViNgoaiHeThong,
  xemKyDienTu,
  checkSoDi,
  DownloadFile,
  getDonViDaBanHanh,
  layLichSuTheoDoiVB,
  exportVB,
  layNguoiXuLyTiepTheo,
  layLuongKyDuyet,
  layDonViNgangCap,
  layLuongXuLy,
  taoVanBanDi,
  uploadFiles,
  layDanhSachVanBanDi,
  layDanhSachVanBanDiTraCuu,
  laySoLuongVanBanDi,
  laySoLuongVanBanDiDashboard,
  xemChiTiet,
  layThongTinChung,
  guiLaiFileDonVi,
  layThongTinGuiVanBan,
  layThongTinYKien,
  suaVanBanDi,
  suaVanBanDiBanHanh,
  trinhKy,
  xoaVanBan,
  xinYKien,
  getDanhSachVanBanDenCuaVanBanDi,
  GetMultiVanBanDen,
  choYKien,
  kySoFile,
  duyetVB,
  capSo,
  traSo,
  nhanSo,
  huyDuyetVB,
  huyTrinhKy,
  traLaiVB,
  layDanhSachNguoiDuocTraLai,
  GetListXinSo,
  banHanhVB,
  banHanhVBLenTruc,
  banHanhVBError,
  danhDauVBKhongBanHanhLai,
  saoChep,
  banHanhBoSung,
  trinhKyTiepTheo,
  thuHoiDaBanHanh,
  layDonViDaBanHanh,
  phanXuLy,
  thuHoiSo,
  layLSCapNhat,
  layLSTraLai,
  layLSThuHoi,
  layLSHuyDuyet,
  layLichSuKyDuyet,
  taoVBDiTrinhKy,
  doiSoVB,
  ganDonViVaoFile,
  layMultiDanhSachVanBanDi,
  updateFileVanBanDi,
  deleteFileVanBanDi,
  getSoDiLonNhat,
  getFileNhieuVanBan,
  xoaYKien,
  suaYKien,
  updateYKien,
  suaXinYKienVanBanDi,
  layLuongXuLyToken,
  lichSuTheoDoiLienThong,
  getSinhSoNoiBo,
  chuyenVung,
  getDanhSachVanThuLanhDaoXinSoBo
};
